export default "__VITE_ASSET__EsMDcmmF__"